import { render, staticRenderFns } from "./TaskStatus.vue?vue&type=template&id=4d60fb97&scoped=true"
import script from "./TaskStatus.vue?vue&type=script&lang=js"
export * from "./TaskStatus.vue?vue&type=script&lang=js"
import style0 from "./TaskStatus.vue?vue&type=style&index=0&id=4d60fb97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d60fb97",
  null
  
)

export default component.exports